import { MESSAGE_EVENTS } from '@/constants/messageEventsConstants';
import { corpService } from '@/service/corpService';
export const niceCheckPlus = {
  createState() {
    return {
      sessionKey: '',
      encryptString: '',
      isCheckNice: false,
    };
  },
  async open(state) {
    const result = await corpService.requestNiceAuthInfo();
    const popup = window.open(result.authUrl, 'niceAuthPopup', 'width=545,height=875,toolbar=yes,location=no');

    if (!popup) {
      throw new Error('팝업이 차단되었습니다. 팝업 차단을 해제해주세요.');
    }

    state.sessionKey = result.sessionKey;
  },
  handleMessage(state, event) {
    const { type, url } = event.data || {};

    if (type !== MESSAGE_EVENTS.NICE_SUCCESS) {
      return;
    }

    state.encryptString = url;
    state.isCheckNice = true;
  },
};
